<template>
  <div class="interface">
    <div
      v-if="!auth"
      class="interface__item"
      :class="[type, {hide: hide}]"
      @click="toggleRightMenu();toogleSingin();"
    >
      <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.8335 5.95839C12.8335 8.48969 10.7814 10.5416 8.25014 10.5416C5.71884 10.5416 3.66675 8.48969 3.66675 5.95839C3.66675 3.42709 5.71884 1.375 8.25014 1.375C10.7814 1.375 12.8335 3.42709 12.8335 5.95839Z"/>
        <path d="M12.1459 12.375H4.35411C1.9534 12.375 0 14.3284 0 16.7291V19.9375C0 20.317 0.307999 20.625 0.6875 20.625H15.8125C16.192 20.625 16.5 20.317 16.5 19.9375V16.7291C16.5 14.3284 14.5466 12.375 12.1459 12.375Z"/>
        <path d="M21.7808 9.12079L18.5724 6.14168C18.4432 6.0215 18.2745 5.95923 18.105 5.95923C17.6503 5.95923 17.4165 6.34612 17.4165 6.64589V8.70839H13.7499C13.243 8.70839 12.8333 9.11894 12.8333 9.625C12.8333 10.1311 13.243 10.5416 13.7499 10.5416H17.4165V12.6041C17.4165 12.9855 17.7263 13.2916 18.104 13.2916C18.2745 13.2916 18.4424 13.2285 18.5724 13.1083L21.7808 10.1292C21.9201 9.99896 21.9999 9.81567 21.9999 9.625C21.9999 9.43433 21.9201 9.25104 21.7808 9.12079Z"/>
      </svg>
    </div>

    <a
      v-if="auth"
      class="interface__item js-router-link"
      :class="[type, {hide: hide}]"
      href="/personal"
    >
      <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.8335 5.58339C15.8335 8.11469 13.7814 10.1666 11.2501 10.1666C8.71884 10.1666 6.66675 8.11469 6.66675 5.58339C6.66675 3.05209 8.71884 1 11.2501 1C13.7814 1 15.8335 3.05209 15.8335 5.58339Z"/>
        <path d="M15.1459 12H7.35411C4.9534 12 3 13.9534 3 16.3541V19.5625C3 19.942 3.308 20.25 3.6875 20.25H18.8125C19.192 20.25 19.5 19.942 19.5 19.5625V16.3541C19.5 13.9534 17.5466 12 15.1459 12Z"/>
      </svg>
    </a>

    <div class="interface__item" :class="type" @click="toggleShoppingCart">
      <svg width="22" height="19" viewBox="0 0 22 19" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.17817 5.25033L8.48742 0.940159C8.66983 0.758659 8.90908 0.666992 9.14833 0.666992C9.71025 0.666992 10.0833 1.12991 10.0833 1.61024C10.0833 1.83941 9.999 2.07224 9.80925 2.26199L6.82092 5.25033H4.17817ZM15.1791 5.25033H17.8218L13.5117 0.940159C13.3302 0.758659 13.0909 0.666992 12.8517 0.666992C12.2898 0.666992 11.9167 1.12991 11.9167 1.61024C11.9167 1.83941 12.001 2.07224 12.1908 2.26199L15.1791 5.25033ZM22 7.08366V8.91699H21.4115C20.922 8.91699 20.4747 9.19658 20.2593 9.63749L16.5 19.0003H5.5L1.74075 9.63566C1.52625 9.19566 1.07892 8.91699 0.589417 8.91699H0V7.08366H22ZM8.25 10.7503C8.25 10.2443 7.83933 9.83366 7.33333 9.83366C6.82733 9.83366 6.41667 10.2443 6.41667 10.7503V15.3337C6.41667 15.8397 6.82733 16.2503 7.33333 16.2503C7.83933 16.2503 8.25 15.8397 8.25 15.3337V10.7503ZM11.9167 10.7503C11.9167 10.2443 11.506 9.83366 11 9.83366C10.494 9.83366 10.0833 10.2443 10.0833 10.7503V15.3337C10.0833 15.8397 10.494 16.2503 11 16.2503C11.506 16.2503 11.9167 15.8397 11.9167 15.3337V10.7503ZM15.5833 10.7503C15.5833 10.2443 15.1736 9.83366 14.6667 9.83366C14.1597 9.83366 13.75 10.2443 13.75 10.7503V15.3337C13.75 15.8397 14.1597 16.2503 14.6667 16.2503C15.1736 16.2503 15.5833 15.8397 15.5833 15.3337V10.7503Z"/>
      </svg>
      <span
        class="interface__description"
        v-if="getNumberOfProductsInCart > 0"
        >{{ getNumberOfProductsInCart }}</span
      >
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    hide: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters('cart', ['getNumberOfProductsInCart']),
    ...mapState('params', ['auth']),
  },
  methods: {
    ...mapMutations('params', [
      'toggleRightMenu',
      'toggleShoppingCart',
      'toogleSingup',
      'toogleSingin',
    ]),
  },
};
</script>

<style lang="sass" scoped>
.interface
  display: flex
  &__item
    position: relative
    display: flex
    justify-content: center
    align-items: center
    width: 48px
    height: 48px
    border-radius: 50%
    cursor: pointer
    transition: all .3s
    svg
      transition: all .3s
    &.main-page
      border: 1px solid #FFFFFF
      svg
        fill: #FFFFFF
    &.products
      border: 1px solid #5599DD
      svg
        fill: #5599DD
    &:not(:last-child)
      margin-right: 16px

    &:hover
      &.main-page,
      &.products
        border: 1px solid #5599DD
        background-color: #5599DD
      svg
        fill: #FFFFFF
    &:active
      transform: scale3d(.98,.98,.98)
      transition: all .2s
    @media screen and ( max-width: 1279px )
      &.hide
        display: none

  &__description
    position: absolute
    bottom: 0
    right: 0
    width: 22px
    height: 22px
    display: flex
    justify-content: center
    align-items: center
    border-radius: 50%
    background-color: #E93232
    font-size: 14px
    line-height: 15px
    font-weight: 500
    color: #FFFFFF

  @media screen and ( max-width: 1279px )
    margin-right: 16px
    &.hide
      display: none
    &__item
      width: 40px
      height: 40px
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/interface.vue